export default __webpack_public_path__ + "static/media/ternary_to_binary.15711349.jpg";